import { render, staticRenderFns } from "./IntraoralMeasureControls.vue?vue&type=template&id=3c556990&scoped=true&"
import script from "./IntraoralMeasureControls.vue?vue&type=script&lang=js&"
export * from "./IntraoralMeasureControls.vue?vue&type=script&lang=js&"
import style0 from "./IntraoralMeasureControls.vue?vue&type=style&index=0&id=3c556990&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c556990",
  null
  
)

export default component.exports